import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../contexts/ProjectContext';
import { toast } from 'sonner';

export function ProjectSelection() {
  const navigate = useNavigate();
  const { availableProjects, switchProject } = useProject();

  const handleSelectProject = async (projectId) => {
    const success = await switchProject(projectId);
    if (success) {
      toast.success(`Przełączono na projekt: ${projectId}`);
      navigate('/');
      window.location.reload(); // Force reload to re-fetch project-specific data
    } else {
      toast.error('Nie udało się zmienić projektu');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Wybierz Projekt
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {availableProjects.map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow cursor-pointer"
              onClick={() => handleSelectProject(project.id)}
            >
              <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                {project.name}
              </h2>
              <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors">
                Wybierz
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}